/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T | (() => T), delay = 500): T {
  const [debounced, setDebounced] = useState(
    typeof value === 'function' ? (value as () => T)() : value,
  );

  useEffect(() => {
    let ignore = false;

    const timer = setTimeout(() => {
      if (!ignore) {
        setDebounced(typeof value === 'function' ? (value as () => T)() : value);
      }
    }, delay);

    return () => {
      ignore = true;
      clearTimeout(timer);
      ignore = true;
    };
  }, [delay, value]);

  return debounced;
}
